import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LandingLayout } from './components/LandingLayout';
import { LandingPage } from './pages/Landing';
import { WaitlistPage } from './pages/Waitlist';
import { ResourcesPage } from './pages/Resources';
import { DashboardPage } from './pages/Dashboard';
import { SettingsPage } from './pages/Settings';

function App() {
  return (
    <Routes>
      {/* Public pages */}
      <Route path="/" element={<LandingLayout />}>
        <Route index element={<LandingPage />} />
        <Route path="waitlist" element={<WaitlistPage />} />
        <Route path="resources" element={<ResourcesPage />} />
      </Route>
      {/* Authenticated dashboard routes */}
      <Route path="/dashboard" element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

export default App;

